// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","286":"d9ccf2d2","455":"7ce8742c","488":"42ea1fd6","967":"af2263fc","977":"b584b783"}[chunkId] + ".chunk.js";
};